<div
  class="card"
  data-cy="challenge_card"
  [id]="challenge().offerId"
  [style.border]="config().cardStyles?.border"
>
  <div
    class="un-card-header"
    [style]="{
      height: config().header.height,
      backgroundColor: config().header.backgroundColor,
    }"
  >
    <!-- Banner -->
    @if (challenge().hasBanner()) {
      @let bannerPath = challenge().productScope.bannerPath;
      <div class="banner">
        @if (loadBannerInPriority()) {
          <img
            fill
            priority
            class="img responsive-width"
            [alt]="config().bannerAlternativeText"
            [ngSrc]="bannerPath!"
          />
        } @else {
          <img
            fill
            class="img responsive-width"
            [alt]="config().bannerAlternativeText"
            [ngSrc]="bannerPath!"
          />
        }
      </div>
    }

    <!-- Logo -->
    @if (!challenge().hasBanner()) {
      <div class="logo-container">
        <div class="box">
          <img
            class="logo"
            [alt]="config().logoAlternativeText"
            [src]="challenge().productScope.logoPath"
          />
        </div>
      </div>
    }
  </div>

  <div class="card-bottom">
    @if (challenge().isCompleted) {
      <b2c-win-card
        class="win-section"
        [subType]="subType()"
        [amount]="challenge().maxPotentialReward"
      />
    } @else {
      <div
        class="card-subheader"
        [style]="{
          color: config().subHeader.color,
          fontFamily: config().subHeader.fontFamily,
          fontSize: config().subHeader.fontSize,
          backgroundColor: config().subHeader.backgroundColor,
        }"
      >
        <p
          class="label"
          b2cTooltipIfTruncated
          [b2cTooltipHideDelay]="80"
          [b2cTooltipShowDelay]="120"
          [b2cTooltipPosition]="'above'"
          [b2cTooltip]="title()"
        >
          {{ title() }}
        </p>
      </div>

      @if (challenge().isSelected) {
        <b2c-progress-section
          class="progress-section"
          [config]="config()"
          [challenge]="challenge()"
        />

        <div class="card-actions">
          @if (challenge().canBeUnselected(phase())) {
            <b2c-unselection-button
              [phase]="phase()"
              [challenge]="challenge()"
              [isBisCampaign]="isBisCampaign()"
              [isEventChallenge]="isEventChallenge()"
            />
          } @else {
            <p
              class="total-spent"
              [style]="{
                color: config().footer.label.color,
                fontFamily: config().footer.label.fontFamily,
              }"
              [innerHTML]="
                config().footer.label.text
                  | replaceVars
                    : (challenge().progress | formatAmount: 'currency')
                  | safe
              "
            ></p>
          }

          @if (phase() !== CampaignPhase.COMPLETED) {
            <button
              b2cElement
              modalType="scanner"
              type="button"
              class="eligible-products"
              data-cy="check_product_btn"
              (click)="displayDialog(challenge(), title())"
              [title]="config().footer.eligibleProductsBtn.ariaLabel"
              [attr.aria-label]="config().footer.eligibleProductsBtn.ariaLabel"
              [style]="{
                color: config().footer.eligibleProductsBtn.color,
                fontFamily: config().footer.eligibleProductsBtn.fontFamily,
              }"
            >
              {{ config().footer.eligibleProductsBtn.label }}
            </button>
          }
        </div>
      } @else {
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [subType]="subType()"
          [challenge]="challenge()"
          class="selection-section"
          data-cy="selection_section"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      }
    }
  </div>
</div>
